import { render } from "./P047.vue?vue&type=template&id=6aef364e&scoped=true"
import script from "./P047.vue?vue&type=script&lang=js"
export * from "./P047.vue?vue&type=script&lang=js"

import "./P047.vue?vue&type=style&index=0&id=6aef364e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aef364e"]])

export default __exports__